import { useContext } from "react";
import common from '../../common.module.css';
import { ModalCopyMaterial } from "../..";
import Select from "@UI/New/Select";
import { filterOptionsByLabel } from "@/helpers/new/filterOptionsByLabel";
import { compareOptionsByLabel } from "@/helpers/new/compareOptionsByLabel";

export const Course = () => {
    const { 
          courses,
          loadingCourses,
          state,
          setFieldInState,
          setMaterials
        } = useContext(ModalCopyMaterial);

    const coursesOptions = courses?.data?.map((course)=>({label: course.name, value: Number(course.id)}));
    const fieldsCourses = {
        loading: loadingCourses,
        showSearch: true,
        allowClear: true,
        filterSort: compareOptionsByLabel,
        filterOption: filterOptionsByLabel,
        onChange: value => {
            setFieldInState({field: 'course', value})
            setFieldInState({field: 'topic_id', value: null});
            setMaterials({})
        },
        options: coursesOptions,
        value: state?.course,
        placeholder: 'Выберите блок',
        notFoundContent: "Курсы не найдены",
        disabled: loadingCourses
    };

    return (
        <>
            {
                courses?.flag_one_block == 1 ? (
                    <div className={common.wrapper}>
                        <span>Этот курс не содержит блоков, копирование произойдет в сам курс</span>
                    </div>
                ) : (
                    <div className={common.wrapper}>
                        <span>Выберите блок</span>
                        <Select 
                            wrapperClassName={common.wrapperSelect} 
                            className={common.select} 
                            fields={fieldsCourses} 
                        />
                    </div>
                )
            }
        </>
    )
}
